import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Layout from '../components/layout/Layout'

const PrivateRoute = ({ component: Component, auth, settings,  ...rest }) => {
  
 return <Route
    {...rest}
    render={(props) => {
      if (auth.isAuthenticated === true) {
                return <Layout><Component  {...rest} {...props} /></Layout>
            } else {
              if(this,props.match.params.db){
                return <Redirect to={'/'+props.match.params.db + "/user/signin"} />
              }else{
                return <Redirect to={"/workspace/signin"} />
                }
              }                
            
        }
    }
  />
  };

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  settings: state.settings
});

export default connect(mapStateToProps)(PrivateRoute);
